module.exports = __webpack_public_path__ + "img/big-img-first-block.dcc0b07b.jpg";